import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { eur } from "@/lib/workflow";
import { useAuth } from "@/context/AuthContext";

export function StornoDialog({ doc, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const chef = !!useAuth().user?.is_chef;
  const [send, setSend] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (doc) { setReason(""); setSend(false); } }, [doc]);
  const save = async () => {
    if (!reason.trim()) { toast.error("Bitte einen Stornogrund angeben"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/documents/${doc.id}/storno`, { reason, send_mail: send });
      toast.success(`Rechnung ${doc.number} storniert (${data.number})${send ? " und versendet" : ""}`);
      onDone();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="storno-dialog">
        <DialogHeader><DialogTitle>Rechnung stornieren</DialogTitle></DialogHeader>
        {doc && (
          <div className="text-sm text-slate-600 space-y-2">
            <div>Rechnung <b>{doc.number}</b> · {doc.customer_name} · <b>{eur(doc.gross)}</b> brutto</div>
            <div className="rounded-md bg-amber-50 border border-amber-200 text-amber-900 text-xs p-2.5">
              Es wird eine Stornorechnung (E-Rechnung) mit eigener Nummer erstellt; die ursprüngliche Rechnung bleibt zur Nachvollziehbarkeit erhalten und wird als „storniert“ markiert.
              Die Anzeige erscheint danach wieder unter „Noch nicht abgerechnet“, sodass Du eine korrigierte Rechnung erstellen kannst.
              {doc.status === "bezahlt" && <b className="block mt-1">Achtung: Diese Rechnung ist bereits bezahlt – eine Erstattung bzw. Verrechnung musst Du separat veranlassen.</b>}
            </div>
          </div>
        )}
        <div className="space-y-3">
          <div><Label>Stornogrund (erscheint auf der Stornorechnung)</Label><Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} placeholder="z. B. falscher Preis berechnet" className="mt-1" data-testid="storno-reason" /></div>
          {chef && <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={send} disabled={!doc?.email} onChange={(e) => setSend(e.target.checked)} data-testid="storno-send" /> Stornorechnung direkt per Mail an {doc?.email || "den Kunden"} senden</label>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="storno-cancel">Abbrechen</Button>
          <Button disabled={busy} onClick={save} className="bg-red-600 hover:bg-red-700" data-testid="storno-save">Rechnung stornieren</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
